'use strict'

import { getStates } from '../services'

import types from './types'

const { FETCH_STATES } = types

function fetchStates() {
  return dispatch =>
    getStates().then(address => {
      dispatch({
        type: FETCH_STATES,
        state: address
      })

      return address
    })
}

export default fetchStates



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchStates.js